import { useEffect } from "react";
import { MotifProgressLoader, MotifIcon } from "@ey-xd/motif-react";
import { useSelector, useDispatch } from "react-redux";
import {
  resetReportState,
  fetchReportListData,
} from "../../store/slices/CTReportListSlice";
import { RootState, AppDispatch } from "../../store";
import "./Report.scss";
import reportListEmptyImg from "../../assets/images/empty_product_list_default.svg";
import ReportCard from "../../components/ReportCard";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import BreadcrumbHome from "../../components/BreadcrumbHome";
import ErrorOrderPage from "../../components/ErrorOrderPage/ErrorOrderPage";

const Report = () => {
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "Home",
      elementKey: "submission",
      text: "Home",
      url: `/`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "Reporting",
      elementKey: "submission",
      text: "Reporting",
      disabled: true,
    },
  ];

  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(resetReportState());
    dispatch(fetchReportListData());
  }, []);

  const isLoading = useSelector(
    (state: RootState) => state.CTReportListSlice.isLoading,
  );
  const data = useSelector((state: RootState) => state.CTReportListSlice.data);
  const error = useSelector(
    (state: RootState) => state.CTReportListSlice.error,
  );

  return (
    <div className="report-container-wrapper">
      <section className="report-header-banner">
        <div className="report-header-content">
          <div className="breadcrumb-grid">
            <BreadcrumbHome
              items={breadcrumbItems}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          <h1 className="report-header-title">Reporting</h1>
          <p className="report-title-description">
            Analyze your orders, recoveries and returns.
          </p>
        </div>
      </section>
      <>
        <section className="report-section">
          <div className="report-card-container" id="report-card-container">
            {isLoading && (
              <MotifProgressLoader
                aria-busy="true"
                aria-label="This page is loading"
                aria-live="polite"
                arialabel="This page is loading"
                show
                variant="default"
                className="report-progress"
              />
            )}

            {
              <>
                {!data && error && (
                  <div className="report-empty-list">
                    <ErrorOrderPage
                      image={reportListEmptyImg}
                      header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                      handleRefresh={() => {
                        dispatch(resetReportState());
                        dispatch(fetchReportListData());
                      }}
                    />
                  </div>
                )}
                {data && !error && (
                  <>
                    {data && data.Data.length > 0 ? (
                      <>
                        <div className="report-list">
                          {data.Data.map((report: any) => (
                            <ReportCard
                              key={report.ReportId}
                              ReportId={report.ReportId}
                              Name={report.Name}
                              Description={report.Description}
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="report-empty-list-default">
                          <div>
                            <img
                              src={reportListEmptyImg}
                              alt="Empty Report List"
                            />
                          </div>
                          <div className="empty-list-header">
                            There are currently no reports available
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            }
          </div>
        </section>
      </>
    </div>
  );
};

export default Report;
